export class NotificationEventPermissionCategory {

    // Static Properties
    public static NextID = -1;

    // Server Properties
    ID: number;
    NotificationEvent_ID: number;
    PermissionCategory: string;
    AddedBy: number;
    AddedOn: Date;
    LastUpdatedBy: number;
    LastUpdatedOn: Date;

    // Local Properties
    originalPermissionCategory: string;

    // Constructor
    constructor() {
        this.ID = NotificationEventPermissionCategory.NextID;
        NotificationEventPermissionCategory.NextID -= 1;
    }
}
